// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SendSvg from '@rsuite/icon-font/lib/action/Send';
var Send = createSvgIcon({
  as: SendSvg,
  ariaLabel: 'send',
  category: 'action',
  displayName: 'Send'
});
export default Send;